import { Component, OnInit } from '@angular/core';
import { FormGroup, FormBuilder, FormControl } from '@angular/forms';
import { Router } from '@angular/router';
import { Observable } from 'rxjs/Observable';
import { DateUtil } from '../../common-app/util/date-util';
import { Kvaw0300Service } from '../../service/kvaw0300.service';
import { Kvaw0900Service } from '../../service/kvaw0900.service';
import { Kvaw1000Service } from '../../service/kvaw1000.service';
import { PrefecturesModel, KaibaModel, Kvaw0300Vo } from '../../service/kvaw0300.vo';
import { OtherStoreModel, Kvaw0900Vo } from '../../service/kvaw0900.vo';
import { MunicipalityModel, Kvaw1000Vo } from '../../service/kvaw1000.vo';
import { OtherStoreViewModel, PrefecturesViewModel, KaibaViewModel, MunicipalityViewModel } from './kvap0500.view-model';
import { SharedService } from '../../common-app/service/shared.service';
import { LocalStorageService } from '../../common-app/service/local-storage.service';
import { Constants } from '../../constants/constants';

@Component({
  templateUrl: './kvap0500.component.html',
  providers: [Kvaw0300Service, Kvaw0900Service, Kvaw1000Service],
})
export class Kvap0500Component implements OnInit {
  /** SharedService key  */
  static STORAGE_KEY_ATSKCODE = 'keyAtskCode';
  static STORAGE_KEY_KOURIKNA = 'keyKouriKna';
  static STORAGE_KEY_PREF = 'keyPref';
  static STORAGE_KEY_CITY = 'keyCity';
  static STORAGE_KEY_CATEGORY = 'keyCategory';
  static STORAGE_KEY_LIST = 'keyList';
  static STORAGE_KEY_STORESYSDATE = 'keyStoreSysdate';
  /** RestAPIForm. */
  public storesForm: FormGroup;
  public OtherStores: OtherStoreViewModel[] = [];
  public PrefecturesList: PrefecturesViewModel[] = [];
  public KaibaList: KaibaViewModel[] = [];
  public MunicipalityList: MunicipalityViewModel[] = [];
  public storeSysdate: string;

  /**
   * コンストラクタ.
   *
   * @param formBuilder FormBuilder
   * @param kvaw0300Service Kvaw0300Service
   * @param kvaw0900Service Kvaw0900Service
   * @param kvaw1000Service Kvaw1000Service
   * @param router Router
   * @param sharedService SharedService
   */
  constructor(
    private formBuilder: FormBuilder,
    private kvaw0300Service: Kvaw0300Service,
    private kvaw0900Service: Kvaw0900Service,
    private kvaw1000Service: Kvaw1000Service,
    private router: Router,
    private sharedService: SharedService,
    private localStorageService: LocalStorageService,
  ) { }

  /**
   * 初期処理
   */
  ngOnInit() {
    // フォームを初期化する
    this.storesForm = this.formBuilder.group({
      atskCode: this.formBuilder.control(''),
      kouriKna: this.formBuilder.control(''),
      pref: this.formBuilder.control(''),
      city: this.formBuilder.control(''),
      category: this.formBuilder.control(''),
    });

    // 共通データ取得処理の呼出
    this.searchShareDataObservable().subscribe();

    // SharedServiceに情報が保持されている場合は初期値として表示する
    // Dコード
    this.storesForm.controls.atskCode.setValue(this.sharedService.get(Kvap0500Component.STORAGE_KEY_ATSKCODE) || '');
    // 都道府県コード
    this.storesForm.controls.pref.setValue(this.sharedService.get(Kvap0500Component.STORAGE_KEY_PREF) || '');
    // 市区町村コード
    this.storesForm.controls.city.setValue(this.sharedService.get(Kvap0500Component.STORAGE_KEY_CITY) || '');
    // 業態コード
    this.storesForm.controls.category.setValue(this.sharedService.get(Kvap0500Component.STORAGE_KEY_CATEGORY) || '');
    // 店舗カナ
    this.storesForm.controls.kouriKna.setValue(this.sharedService.get(Kvap0500Component.STORAGE_KEY_KOURIKNA) || '');
    // 業務日付
    this.storeSysdate = this.sharedService.get(Kvap0500Component.STORAGE_KEY_STORESYSDATE) || '';
    // 検索結果
    this.OtherStores = this.sharedService.get(Kvap0500Component.STORAGE_KEY_LIST) || [];
    // 共通データから取得した場合も一時保存情報を確認し、反映する。
    this.OtherStores.forEach(record => {
      record.saved = this.localStorageService.load(Constants.LOCAL_SAVE_KEY_GROUP_COMPANY_CODE + this.storeSysdate + record.storeCode) ? true : false;
    });

    // 都道府県コードが保存されている場合は市区町村コードの取得を実施
    if (this.sharedService.get(Kvap0500Component.STORAGE_KEY_PREF)) {
      // 市区町村リスト取得処理の呼出
      this.searchMunicipalityObservable(this.storesForm.controls.pref.value).subscribe();
    }
  }

  /**
   * 検索ボタンクリック処理
   */
  searchButtonClick() {
    // 検索条件の何れか必須チェック
    if (
      !this.storesForm.controls.atskCode.value
      && !this.storesForm.controls.kouriKna.value
      && !this.storesForm.controls.pref.value
      && !this.storesForm.controls.city.value
      && !this.storesForm.controls.category.value
    ) {
      // 検索条件のいずれも入力されていない場合はメッセージを表示して終了
      alert('検索条件の何れかを入力してください');
      return;
    }
    // Dコードの文字チェック（半角英数字のみ許可）
    if (this.inputCheckDcode(this.storesForm.controls.atskCode.value) === false) {
      // 半角英数以外が入力された場合はメッセージを表示して終了
      alert('Dコードは半角英数字で入力してください');
      return;
    }

    // 店舗カナ名の文字チェック（全角カナ、全角数字、全角（）、全角スペースのみ許可）
    if (this.inputCheckKana(this.storesForm.controls.kouriKna.value) === false) {
      // 全角カナ・全角数字・全角（）・全角括弧以外が入力された場合はメッセージを表示して終了
      alert('店舗カナ名は全角カナで入力してください');
      return;
    }

    // 検索処理の呼出
    this.searchOtherStoreObservable().subscribe();
  }

  /**
   * 都道府県コンボボックス変更処理
   */
  changePref() {
    // 市区町村リスト取得処理の呼出
    if (this.storesForm.controls.pref.value) {
      // 都道府県が選択されたら、市区町村の選択状態を一旦クリア
      this.storesForm.controls.city.setValue('');
      // 都道府県が選択されている場合は市区町村リストを取得
      this.searchMunicipalityObservable(this.storesForm.controls.pref.value).subscribe();
    } else {
      // 都道府県が選択されていない場合は市区町村リストをクリア
      this.MunicipalityList = null;
      this.storesForm.controls.city.setValue('');
    }
    // 共有データサービスに検索条件と検索結果を保存
    // 都道府県コード
    this.sharedService.set(Kvap0500Component.STORAGE_KEY_PREF, this.storesForm.controls.pref.value);
    // 市区町村コード
    this.sharedService.set(Kvap0500Component.STORAGE_KEY_CITY, this.storesForm.controls.city.value);
  }

  /**
   * 市区町村コンボボックス変更処理
   */
  changeCity() {
    // 共有データサービスに検索条件と検索結果を保存
    // 市区町村コード
    this.sharedService.set(Kvap0500Component.STORAGE_KEY_CITY, this.storesForm.controls.city.value);
  }

  /**
   * 業態コンボボックス変更処理
   */
  changeCategory() {
    // 共有データサービスに検索条件と検索結果を保存
    // 業態コード
    this.sharedService.set(Kvap0500Component.STORAGE_KEY_CATEGORY, this.storesForm.controls.category.value);
  }

  /**
   * 担当外店舗一覧を検索する
   */
  searchOtherStoreObservable(): Observable<Kvaw0900Vo> {
    const atskCodeVal = this.storesForm.get('atskCode').value ? 'D' + this.storesForm.get('atskCode').value : this.storesForm.get('atskCode').value;
    return this.kvaw0900Service.searchOtherStore
      (
      atskCodeVal,
      this.storesForm.get('kouriKna').value,
      this.storesForm.get('pref').value,
      this.storesForm.get('city').value,
      this.storesForm.get('category').value,
    )
      .map(responseVo => {
        this.OtherStores = responseVo.stores
          .map(report => <OtherStoreViewModel>{
            groupCompanyCode: report.groupCompanyCode,
            storeCode: report.storeCode,
            storeName: report.storeName,
            storeKanaName: report.storeKanaName,
            chainCode: report.chainCode,
            chainCodeBranchNum: report.chainCodeBranchNum,
            kaibaCode: report.kaibaCode,
            saved: this.localStorageService.load(Constants.LOCAL_SAVE_KEY_GROUP_COMPANY_CODE + responseVo.sysdate + report.storeCode) ? true : false,
          });
        this.storeSysdate = responseVo.sysdate;

        // 共有データサービスに検索条件と検索結果を保存
        // Dコード
        this.sharedService.set(Kvap0500Component.STORAGE_KEY_ATSKCODE, this.storesForm.controls.atskCode.value);
        // 都道府県コード
        this.sharedService.set(Kvap0500Component.STORAGE_KEY_PREF, this.storesForm.controls.pref.value);
        // 市区町村コード
        this.sharedService.set(Kvap0500Component.STORAGE_KEY_CITY, this.storesForm.controls.city.value);
        // 業態コード
        this.sharedService.set(Kvap0500Component.STORAGE_KEY_CATEGORY, this.storesForm.controls.category.value);
        // 店舗カナ
        this.sharedService.set(Kvap0500Component.STORAGE_KEY_KOURIKNA, this.storesForm.controls.kouriKna.value);
        // 検索結果
        this.sharedService.set(Kvap0500Component.STORAGE_KEY_LIST, this.OtherStores);
        // 業務日付
        this.sharedService.set(Kvap0500Component.STORAGE_KEY_STORESYSDATE, this.storeSysdate);

        return responseVo;
      });
  }

  /**
   * 共通データを取得する
   */
  searchShareDataObservable(): Observable<Kvaw0300Vo> {
    return this.kvaw0300Service.searchShareData()
      .map(responseVo => {

        // 表示用に値を変換
        // 都道府県リスト
        this.PrefecturesList = responseVo.prefecturesList
          .map(pList => <PrefecturesViewModel>{
            prefecturesCode: pList.prefecturesCode,
            prefecturesName: pList.prefecturesName,
          });

        // 買場リスト
        this.KaibaList = responseVo.kaibaList
          .map(kList => <KaibaViewModel>{
            kaibaCode: kList.kaibaCode,
            kaibaName: kList.kaibaName,
          });
        return responseVo;
      });
  }

  /**
   * 市区町村データを取得する
   */
  searchMunicipalityObservable(prefecturesCode: string): Observable<Kvaw1000Vo> {
    return this.kvaw1000Service.searchMunicipality(prefecturesCode).map(responseVo => {

      // 表示用に値を変換
      // 市区町村リスト
      this.MunicipalityList = responseVo.municipalityList
        .map(mList => <MunicipalityViewModel>{
          municipalityCode: mList.municipalityCode,
          municipalityName: mList.municipalityName,
        });
      return responseVo;
    });
  }

  /**
   * 日報報告画面に遷移する.
   */
  report(model: OtherStoreModel) {
    // 日報報告画面を呼出
    this.router.navigate(['/kvap0800'], {
      queryParams: {
        storeCode: model.storeCode,
        deliveryDate: this.storeSysdate.toString(),
        chainCode: model.chainCode,
        chainCodeBranchNum: model.chainCodeBranchNum,
        kaibaCode: model.kaibaCode,
        isOutside: 'true'
      }
    });
  }

  /**
   * 半角数字チェック処理
   */
  inputCheckDcode(checkString: string) {
    if (checkString.match(/[^0-9]+/)) {
      // 半角数字以外の文字が存在する場合、エラー
      return false;
    }
    return true;
  }

  /**
   * 全角カナチェック処理
   */
  inputCheckKana(checkString: string) {
    if (checkString.match(/[^ァ-ン０-９ー－（）　+]+/)) {
      // 全角カナと全角数字と全角（）全角ーと全角スペース以外の文字が存在する場合、エラー
      return false;
    }
    return true;
  }

}



// WEBPACK FOOTER //
// ./src/app/component/kvap0500/kvap0500.component.ts